<template>
    <div class="coupon-box">
        <div class="coupon-content">
            <div class="coupon-title">乘车权益券</div>
            <div class="coupon-line"></div>
            <div v-if="partQual" class="coupon-num">可使用次数：{{ partTimes }}</div>
            <div v-else class="coupon-num">未获取到权益</div>
        </div>

        <div class="tip-box">
            <div class="tip-title">温馨提示：</div>
            <div class="tip-text">因公交车载机为脱机交易，上送扣款时间可能会有延迟，实际可用优惠次数以系统扣款成功时间核算为准。</div>
        </div>

        <div v-if="isFromBjqd" class="btn-box">
            <div class="ride-btn" @click="handleGoRide">去乘车</div>
        </div>
    </div>
</template>

<script>

import { setStore } from '@/utils/index'
import { Toast, Dialog } from 'vant'
import { queryUserConsumeActivityPartQual } from '@/api/active'

export default {
  name: 'icbcCouponNum',
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      appCode: 'BJQD',
      isFromBjqd: false, // 是否来自于便捷青岛APP
      activityNo: '', // 活动编号 有活动时返回 无活动时返回空
      partQual: true, // 当前用户是否有资格参与 true 有资格 false 无资格
      partTimes: 0 // 当前用户剩余可参与次数
    }
  },
  mounted () {
    const accessToken = this.$route.query.accessToken
    this.appCode = this.$route.query.appCode || ''
    if (accessToken) {
      setStore('token', accessToken)
    }
    const fromBjqd = this.$route.query.fromBjqd
    if (fromBjqd === '1') {
      this.isFromBjqd = true
    }
    this.queryActivityPartQual()
  },
  methods: {
    // 去乘车
    handleGoRide () {
      if (this.appCode === 'QDT') {
        let item = {
          finishCurrentPage: 1,
          appId: '100299999',
          authorize: 0,
          androidGoPage: '/ReactNative/QDTHomeActivity',
          iosGoPage: 'QDTViewController',
          appType: 1,
          goPage: 'TripHome'
        }

        window.ReactNativeWebView.postMessage(JSON.stringify(item))
      } else {
        const data = {
          androidGoPage: '/ReactNative/QDTHomeActivity',
          iosGoPage: 'QDTViewController',
          appType: 0,
          appStartUrl: 'TripHome'
        }
        /* eslint-disable */
        dsBridge.call("callNativeViewLifeCycle", {
          ...data
        });
      }
    },

    // 乘车码优惠活动资格查询
    queryActivityPartQual () {
      const requestData = {
      }
      queryUserConsumeActivityPartQual(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          const datas = res.data.result
          this.activityNo = datas.activityNo
          this.partQual = datas.partQual
          this.partTimes = datas.partTimes
          if (!this.activityNo) {
            Toast({
              message: '暂无活动'
            })
          } else if (!this.partQual) {
            if (this.isFromBjqd) {
              Dialog.confirm({
                title: '温馨提示',
                message: '您尚未参与活动，请到活动页面领取乘车权益券',
                cancelButtonText: '取消',
                confirmButtonText: '去参加',
                confirmButtonColor: '#4F7DFF'
              }).then(() => {
                this.$router.replace({ path: '/bjqdActivity', query: { accessToken: this.token } })
              }).catch(() => {

              })
            } else {
              Toast({
                message: '您尚未参与活动，请到活动页面领取乘车权益券'
              })
            }
            
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-box {
    position: relative;
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tip-box {
    margin-top: 16px;
    width: (690vw / 7.5);
    display: flex;
    flex-direction: column;
    .tip-title {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
    }
    .tip-text {
        margin-top: 5px;
        font-weight: 400;
        font-size: 13px;
        color: #606060;
        line-height: 18px;
    }
}

.btn-box {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .ride-btn {
        width: (690vw / 7.5);
        height: 40px;
        background: #4F7DFF;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 14px;
        color: #fff;
    }
}

.coupon-content {
    margin-top: 30px;
    width: (690vw / 7.5);
    height: 80px;
    background: #FFF9EE;
    border: 1px solid #F4E7CF;
    border-radius: 8px;    
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #785A22;

    .coupon-title {
        width: (344vw / 7.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .coupon-line {
        width: 1px;
        height: 30px;
        background: #DFCAA3;
    }

    .coupon-num {
        width: (344vw / 7.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}

</style>
